"use strict";

exports.__esModule = true;
exports.default = addHours;
/** @module utils/DateUtils/addHours */

/**
 * Adds hours to a date.
 *
 * @param {Date} time the time to increment
 * @param {number} hours the number of hours to increment by.
 * @return a new Date with the new hours set.
 */
function addHours(time, hours) {
  var t = new Date(time.getTime());
  t.setHours(t.getHours() + hours);
  return t;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/utils/DateUtils/addHours.js
// module id = 919
// module chunks = 213534597649335